<template>
  <div 
  v-bind:class="{'full-screen': isFullSceenActive}"
  class="camera">

    <template v-if="currentCameraId">

      <!-- Header -->
      <transition name="fade" mode="out-in" appear>
      <div 
      v-show="!isFullSceenActive"
      class="header">

        <!-- Menu button -->
        <div 
        v-bind:class="{active: isMenuActive}" 
        v-on:click="onClickClose()" 
        class="close-btn" ontouchstart="">
          <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            <path d="M0 0h24v24H0z" fill="none"/>
          </svg>
        </div><!-- Menu button -->

        <!-- Menu title -->
        <div class="header-title">
          {{currentCamera.name}}
        </div><!-- Menu title -->

      </div><!-- Header -->
      </transition>

      <div class="main">

        <!-- Body -->
        <div class="body">

          <!-- Camera container -->
          <div class="camera-container">

            <!-- Live tab selected -->
            <div 
            v-show="tabs[selectedTabIndex] === 'live'"
            class="content">
              <div 
              v-on:click="disableFullSceen()"
              v-if="!currentCamera.isOnline"
              class="svg-icon">
                <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none"/>
                  <path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"/>
                </svg>
              </div>
              <img 
              v-on:click="disableFullSceen()"
              v-if="currentCamera.isOnline && currentCameraLiveSnapshot"
              v-bind:src="currentCameraLiveSnapshot.url">

              <transition name="fade" mode="out-in" appear>
              <div 
              v-if="!isFullSceenActive"
              class="control-container">

                <!-- Clickable layer -->
                <div 
                v-on:click="enableFullSceen()"
                class="clickable-layer">
                </div><!-- Clickable layer -->

                <!-- Video info -->
                <div
                class="video-info">
                  <div 
                  v-on:click="toggleTab()"
                  v-bind:class="{'playback': tabs[selectedTabIndex] === 'playback'}"
                  class="info-title">
                    {{tabs[selectedTabIndex]}}
                  </div>
                  <div class="info-text">
                    {{currentCameraLiveSnapshot ? currentSite.convertToLocalTime(currentCameraLiveSnapshot.timestamp).toLocaleTimeString() : 
                    currentCameraStatusGetLiveSnapshot === 'requested' ? 'loading...' :
                    !currentCamera.isOnline ? 'offline' : 'no info'}}
                  </div>
                </div><!-- Video info -->

              </div>
              </transition>

            </div><!-- Live tab selected -->

            <!-- Playback tab selected -->
            <div
            v-if="currentCamera.thumbnailVideos"
            v-show="tabs[selectedTabIndex] === 'playback'"
            class="content">
              <div 
              v-show="!thumbnailVideo(currentCamera.thumbnailVideos[dates[selectedDateIndex]])"
              class="no-recording-text">No recording</div>
              <video
              v-on:click="disableFullSceen()"
              v-show="thumbnailVideo(currentCamera.thumbnailVideos[dates[selectedDateIndex]])"
              ref="thumbnailVideo"
              webkit-playsinline
              playsinline></video>


              <transition name="fade" mode="out-in" appear>
              <div 
              v-show="thumbnailVideo(currentCamera.thumbnailVideos[dates[selectedDateIndex]]) && !isFullSceenActive"
              class="control-container">

                <!-- Clickable layer -->
                <div 
                v-on:click="enableFullSceen()"
                class="clickable-layer">
                </div><!-- Clickable layer -->


                <!-- Loading status container -->
                <div v-if="!isThumbnailVideoLoaded" class="loading-status">
                  Loading...
                </div><!-- Loading status container -->


                <!-- Video info -->
                <div 
                v-bind:class="{'playback': tabs[selectedTabIndex] === 'playback'}"
                class="video-info">
                  <div 
                  v-on:click="toggleTab()"
                  class="info-title">
                    {{isRecordingVideoActive ? tabs[selectedTabIndex] : (+thumbnailVideoPlaybackRates[thumbnailVideoDefaultPlaybackRateIndex] * 10 * 60) + 'x'}}
                  </div>
                  <div class="info-text">
                    {{isThumbnailVideoLoaded ? hours[selectedHourIndex] + ':' + minutes[selectedMinuteIndex] + ':00 ' + getAmPm(selectedHourIndex) : 'loading...'}}
                  </div>
                </div><!-- Video info -->



                <!-- Playback control container -->
                <div v-if="isThumbnailVideoLoaded" class="playback-control-container">

                  <!-- Backward button -->
                  <div class="control-btn">
                    <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path d="M0 0h24v24H0V0z" id="a"/>
                      </defs>
                      <clipPath id="b">
                        <use overflow="visible" xlink:href="#a"/>
                      </clipPath>
                      <path clip-path="url(#b)" d="M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"/>
                    </svg>
                  </div><!-- Backward button -->

                  <!-- Fast rewind button -->
                  <div 
                  v-on:click="onClickFastRewind()"
                  class="control-btn">
                    <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"/>
                      <path d="M0 0h24v24H0z" fill="none"/>
                    </svg>
                  </div><!-- Fast rewind button -->

                  <!-- Play/Pause button -->
                  <div 
                  v-on:click="onClickPlayAndPause()"
                  class="control-btn">
                    <svg 
                    v-if="!isThumbnailVideoPaused"
                    fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                      <path d="M0 0h24v24H0z" fill="none"/>
                    </svg>
                    <svg 
                    v-else
                    fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 5v14l11-7z"/>
                      <path d="M0 0h24v24H0z" fill="none"/>
                    </svg>
                  </div><!-- Play/Pause button -->

                  <!-- Fast forward button -->
                  <div 
                  v-on:click="onClickFastForward()"
                  class="control-btn">
                    <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"/>
                      <path d="M0 0h24v24H0z" fill="none"/>
                    </svg>
                  </div><!-- Fast forward button -->

                  <!-- Foreward button -->
                  <div class="control-btn">
                    <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path d="M24 24H0V0h24v24z" id="a"/>
                      </defs>
                      <clipPath id="b">
                        <use overflow="visible" xlink:href="#a"/>
                      </clipPath>
                      <path clip-path="url(#b)" d="M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"/>
                    </svg>
                  </div><!-- Foreward button -->

                </div><!-- Playback control container -->


              </div>
              </transition>
              
            </div>

          </div><!-- Camera container -->

        </div> <!-- Body -->

      </div>

      <!-- Footer -->
      <transition name="fade" mode="out-in" appear>
      <div 
      v-show="!isFullSceenActive"
      class="footer">

        <!-- Control container -->
        <div class="camera-control-container">
        
          <!-- Timeline container -->
          <div 
          v-if="currentCamera.thumbnailVideos"
          v-show="tabs[selectedTabIndex] === 'playback'"
          class="timeline-container">

            <!-- Date container -->
            <div class="dates-container">
                &nbsp;
              <h-scroll-comp
              v-bind:refreshTrigger="refreshHScrollCompCount"
              v-bind:itemWidth="100"
              v-bind:selectedItem="selectedDateIndex"
              v-bind:totalItems="dates.length">
                <div 
                v-for="(value, index) in dates"
                v-bind:key="value"
                v-on:click="onClickDate(index)"
                v-bind:class="{
                  'selected': index === selectedDateIndex,
                  'has-recording': thumbnailVideo(currentCamera.thumbnailVideos[value])
                }"
                class="date">
                  {{value}}
                </div>
              </h-scroll-comp>
            </div>

            <!-- Hour container -->
            <div class="dates-container">
                &nbsp;
              <h-scroll-comp
              v-bind:refreshTrigger="refreshHScrollCompCount"
              v-bind:itemWidth="100"
              v-bind:selectedItem="selectedHourIndex"
              v-bind:totalItems="hours.length">
                <div 
                v-for="(value, index) in hours"
                v-bind:key="value"
                v-on:click="onClickHour(index)"
                v-bind:class="{selected: index === selectedHourIndex}"
                class="date">
                  {{value + getAmPm(index)}}
                </div>
              </h-scroll-comp>
            </div>

            <!-- Minute container -->
            <div class="dates-container">
                &nbsp;
              <h-scroll-comp
              v-bind:refreshTrigger="refreshHScrollCompCount"
              v-bind:itemWidth="100"
              v-bind:selectedItem="selectedMinuteIndex"
              v-bind:totalItems="minutes.length">
                <div 
                v-for="(value, index) in minutes"
                v-bind:key="value"
                v-on:click="onClickMinute(index)"
                v-bind:class="{selected: index === selectedMinuteIndex}"
                class="date">
                  {{value}}
                </div>
              </h-scroll-comp>
            </div>

          </div><!-- Timeline container -->

          <!-- Action buttons -->
          <div class="action-btns">
            <div 
            v-for="(value, index) in tabs"
            v-bind:key="index"
            v-on:click="selectTab(index)"
            v-bind:class="{
              'selected': index === selectedTabIndex,
              'playback': value === 'playback'
            }"
            class="action-btn">{{value}}</div>
          </div><!-- Action buttons -->

        </div><!-- Control container -->

      </div><!-- Footer -->
      </transition>

    </template>

  </div>
</template>

<script>
import HScrollComp from './HScrollComp'

export default {
  name: 'camera',
  components: { HScrollComp },
  created: function () {
    this.initializeMockupData()
    // let cameraId = this.$route.params.cameraId
    // console.log('cameraId: ' + cameraId)
    this.$store.commit('CLOSE_MENU')
    this.$store.dispatch('getThumbnailVideos', {cameraId: this.currentCameraId})
    // temporary solution (Below)
    if (!this.currentCameraId) this.onClickClose()
    this.startRefreshingCameraLiveSnapshot()
  },
  mounted: function () {
    this.$forceUpdate()
  },
  beforeDestroy: function () {
    this.pauseThumbnailVideo()
    this.stopRefreshingCameraLiveSnapshot()
  },
  data () {
    return {
      refreshingCameraLiveSnapshot$1: null,
      tabs: ['playback', 'live'],
      selectedTabIndex: 1,
      isFullSceenActive: false,
      refreshHScrollCompCount: 0,
      dates: [],
      hours: [],
      minutes: [],
      recordingVideoUrls: [],
      thumbnailVideoUrls: [],
      selectedDateIndex: null,
      selectedHourIndex: null,
      selectedMinuteIndex: null,
      oneHourInThumbnailVideo: 1 / 30 * 60, // 1min / 30fps * 60mins
      oneMinuteInThumbnailVideo: 1 / 30, // 1min / 30fps
      syncingThumbnailVideoCurrentTimeWithTimeline$i: null,
      syncingRecordingVideoCurrentTimeWithTimeline$i: null,
      isRecordingVideoPaused: true,
      isRecordingVideoLoaded: false,
      isThumbnailVideoPaused: true,
      isThumbnailVideoLoaded: false,
      recordingVideoPlaybackRates: [1],
      recordingVideoDefaultPlaybackRateIndex: 0,
      thumbnailVideoPlaybackRates: [0.1, 0.5, 1],
      thumbnailVideoDefaultPlaybackRateIndex: 0,
      isRecordingVideoActive: true
    }
  },
  computed: {
    isMenuActive: function () {
      return this.$store.getters.isMenuActive
    },
    currentSiteId: function () {
      return this.$store.getters.currentSiteId
    },
    currentSite: function () {
      return this.$store.getters.currentSite
    },
    currentCameraId: function () {
      return this.$store.getters.currentCameraId
    },
    currentCamera: function () {
      return this.$store.getters.currentCamera
    },
    currentCameraLiveSnapshot: function () {
      return this.$store.getters.currentCameraLiveSnapshot
    },
    currentCameraStatusGetLiveSnapshot: function () {
      return this.$store.getters.currentCameraStatusGetLiveSnapshot
    },
    camera: function () {
      return this.$store.getters.camera
    },
    thumbnailVideo: function () {
      return this.$store.getters.thumbnailVideo
    },
    statusGetLiveSnapshot: function () {
      return this.$store.getters.statusGetLiveSnapshot
    },
    liveSnapshot: function () {
      return this.$store.getters.liveSnapshot
    }
  },
  methods: {
    onClickClose: function () {
      // this.$router.push({ name: 'cameras', params: { siteId: 123 }})
      this.$router.push({ name: 'cameras' })
    },
    startRefreshingCameraLiveSnapshot: function () {
      let refreshInterval = 1000 * 0.2 // 1 sec
      this.stopRefreshingCameraLiveSnapshot()
      this.refreshingCameraLiveSnapshot$i = setInterval(() => {
        this.getCameraLiveSnapshot()
      }, refreshInterval)
    },
    stopRefreshingCameraLiveSnapshot: function () {
      if (this.refreshingCameraLiveSnapshot$i) {
        clearInterval(this.refreshingCameraLiveSnapshot$i)
        this.refreshingCameraLiveSnapshot$i = null
      }
    },
    getCameraLiveSnapshot: function () {
      if (this.currentCamera) {
        if (
          this.currentCamera.isOnline &&
          this.currentCameraStatusGetLiveSnapshot !== 'requested'
        ) {
          this.$store.dispatch('getLiveSnapshot', this.currentCameraId)
        }
      }
    },
    toggleTab: function () {
      if (this.isRecordingVideoActive && this.isThumbnailVideoPaused) {
        let targetTabIndex = this.selectedTabIndex + 1
        if (targetTabIndex === this.tabs.length) targetTabIndex = 0
        this.selectTab(targetTabIndex)
      }
    },
    selectTab: function (index) {
      if (this.tabs[index]) {
        this.selectedTabIndex = index
      }
    },
    initializeTheWayRecordingVideoShow: function (src) {
      if (this.$refs.recordingVideo) {
        if (src) {
          this.$refs.recordingVideo.src = src
          this.$refs.recordingVideo.controls = false
          this.setRecordingVideoDefaultPlaybackRate()
          this.isRecordingVideoLoaded = false
          this.$refs.recordingVideo.onloadedmetadata = function () {
            this.onLoadedRecordingVideoMetadata()
          }.bind(this)
          this.$refs.recordingVideo.onpause = function () {
            this.pauseRecordingVideo()
          }.bind(this)
          this.$refs.recordingVideo.load()
        } else {
          this.$refs.recordingVideo.src = ''
        }
      }
    },
    initializeTheWayThumbnailVideoShow: function (src) {
      if (this.$refs.thumbnailVideo) {
        if (src) {
          this.$refs.thumbnailVideo.src = src
          this.$refs.thumbnailVideo.controls = false
          this.setThumbnailVideoDefaultPlaybackRate()
          this.isThumbnailVideoLoaded = false
          this.$refs.thumbnailVideo.onloadedmetadata = function () {
            this.onLoadedThumbnailVideoMetadata()
          }.bind(this)
          this.$refs.thumbnailVideo.onpause = function () {
            this.pauseThumbnailVideo()
          }.bind(this)
          this.$refs.thumbnailVideo.load()
        } else {
          this.$refs.thumbnailVideo.src = ''
        }
      }
    },
    setRecordingVideoDefaultPlaybackRate: function (rate) {
      if (this.$refs.recordingVideo) {
        this.$refs.recordingVideo.defaultPlaybackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex]
        this.$refs.recordingVideo.playbackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex]
      }
    },
    setThumbnailVideoDefaultPlaybackRate: function (rate) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.defaultPlaybackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex]
        this.$refs.thumbnailVideo.playbackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex]
      }
    },
    onLoadedRecordingVideoMetadata: function () {
      this.isRecordingVideoLoaded = true
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        let videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo
        this.updateVideoCurrentTime(videoCurrentTime)
        setTimeout(() => { this.resetTimeIndexes() }, 300)
      }
      if (this.isRecordingVideoPaused) {
        this.pauseRecordingVideo()
      } else {
        this.playRecordingVideo()
      }
    },
    onLoadedThumbnailVideoMetadata: function () {
      this.isThumbnailVideoLoaded = true
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        let videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo
        this.updateVideoCurrentTime(videoCurrentTime)
        setTimeout(() => { this.resetTimeIndexes() }, 300)
      }
      if (this.isThumbnailVideoPaused) {
        this.pauseThumbnailVideo()
      } else {
        this.playThumbnailVideo()
      }
    },
    getAmPm: function (hourIndex) {
      if (hourIndex < 12) return 'am'
      else return 'pm'
    },
    initializeMockupData: function () {
      this.dates = []
      this.thumbnailVideoUrls = []
      let todayDateId = this.currentSite.todayDateId()
      for (let i = 0; i < 32; i++) {
        this.dates.push(todayDateId - i * (60 * 60 * 24))
        this.thumbnailVideoUrls.push(null)
      }
      this.hours = []
      for (let i = 0; i < 24; i++) {
        this.hours.push(i === 0 ? '12' : i < 12 ? i : i === 12 ? '12' : (i - 12))
      }
      this.minutes = []
      for (let i = 0; i < 60; i++) {
        this.minutes.push(i < 10 ? '0' + i : i + '')
      }
      this.recordingVideoUrls = [
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4',
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4',
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'
      ]
      this.thumbnailVideoUrls[this.dates.length - 1] = 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4'
      this.thumbnailVideoUrls[this.dates.length - 2] = 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4'
      this.thumbnailVideoUrls[this.dates.length - 3] = 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'

      this.$nextTick(() => {
        this.selectDate(0)
        this.selectHour(8)
        this.selectMinute(30)
      })
    },
    onClickDate: function (dateIndex) {
      this.selectDate(dateIndex)
    },
    selectDate: function (dateIndex) {
      if (this.selectedDateIndex !== dateIndex) {
        if (this.currentCamera.thumbnailVideos) {
          if (this.thumbnailVideo(this.currentCamera.thumbnailVideos[this.dates[dateIndex]])) {
            if (this.thumbnailVideo(this.currentCamera.thumbnailVideos[this.dates[dateIndex]]).isThumbnailVideoCreated) {
              this.initializeTheWayThumbnailVideoShow(this.thumbnailVideo(this.currentCamera.thumbnailVideos[this.dates[dateIndex]]).url)
              this.initializeTheWayRecordingVideoShow(this.thumbnailVideo(this.currentCamera.thumbnailVideos[this.dates[dateIndex]]).url)
              this.selectedDateIndex = dateIndex
            }
          } else {
            this.pauseThumbnailVideo()
            this.selectedDateIndex = dateIndex
          }
        }
      } else {
        this.refreshHScrollCompo()
      }
    },
    goToBeforeMinute: function () {
      if (this.selectedMinuteIndex === 0) {
        // Go to before hour
        if (this.selectedHourIndex > 0) {
          this.onClickHour(this.selectedHourIndex - 1)
          this.onClickMinute(this.minutes.length - 1)
        }
      } else {
        // Go to before minute
        this.onClickMinute(this.selectedMinuteIndex - 1)
      }
    },
    goToNextMinute: function () {
      if (this.minutes.length - 1 === this.selectedMinuteIndex) {
        // Go to next hour
        if (this.selectedHourIndex < this.hours.length - 1) {
          this.onClickHour(this.selectedHourIndex + 1)
          this.onClickMinute(0)
        }
      } else {
        // Go to next minute
        this.onClickMinute(this.selectedMinuteIndex + 1)
      }
    },
    onClickHour: function (hourIndex) {
      if (this.selectedHourIndex !== hourIndex) {
        this.selectHour(hourIndex)
        let videoCurrentTime = hourIndex * this.oneHourInThumbnailVideo + this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo
        this.updateVideoCurrentTime(videoCurrentTime)
        setTimeout(() => { this.resetTimeIndexes() }, 300)
      } else {
        this.refreshHScrollCompo()
      }
    },
    selectHour: function (hourIndex) {
      this.selectedHourIndex = hourIndex
    },
    onClickMinute: function (timeIndex) {
      if (this.selectedMinuteIndex !== timeIndex) {
        this.selectMinute(timeIndex)
        let videoCurrentTime = timeIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo
        this.updateVideoCurrentTime(videoCurrentTime)
        setTimeout(() => { this.resetTimeIndexes() }, 300)
      } else {
        this.refreshHScrollCompo()
      }
    },
    selectMinute: function (timeIndex) {
      this.selectedMinuteIndex = timeIndex
    },
    updateVideoCurrentTime: function (time) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.currentTime = time + 0.001
      }
    },
    refreshHScrollCompo: function () {
      this.refreshHScrollCompCount++
    },
    onClickFastRewind: function () {
      // is Recording video paused?
      if (this.isThumbnailVideoPaused) {
        this.goToBeforeMinute()
      } else {
        if (this.isRecordingVideoActive) {
          this.isRecordingVideoActive = false
          this.setThumbnailVideoDefaultPlaybackRate()
        } else {
          let index = this.thumbnailVideoDefaultPlaybackRateIndex - 1
          if (index < 0) index = 0
          this.thumbnailVideoDefaultPlaybackRateIndex = index
          this.setThumbnailVideoDefaultPlaybackRate()
        }
      }
    },
    onClickFastForward: function () {
      // is Recording video paused?
      if (this.isThumbnailVideoPaused) {
        this.goToNextMinute()
      } else {
        if (this.isRecordingVideoActive) {
          this.isRecordingVideoActive = false
          this.setThumbnailVideoDefaultPlaybackRate()
        } else {
          let index = this.thumbnailVideoDefaultPlaybackRateIndex + 1
          if (index >= this.thumbnailVideoPlaybackRates.length) index = index - 1
          this.thumbnailVideoDefaultPlaybackRateIndex = index
          this.setThumbnailVideoDefaultPlaybackRate()
        }
      }
    },
    resetPlaybackConfigurations: function () {
      this.isRecordingVideoActive = true
      this.recordingVideoDefaultPlaybackRateIndex = 0
      this.thumbnailVideoDefaultPlaybackRateIndex = 0
      this.setThumbnailVideoDefaultPlaybackRate()
    },
    onClickActionBtnForRecordingVideo: function () {
      if (this.$refs.recordingVideo) {
        if (this.$refs.recordingVideo.paused) this.playRecordingVideo()
        else this.pauseRecordingVideo()
      }
    },
    onClickPlayAndPause: function () {
      if (this.$refs.thumbnailVideo) {
        if (this.$refs.thumbnailVideo.paused) this.playThumbnailVideo()
        else this.pauseThumbnailVideo()
        this.resetPlaybackConfigurations()
      }
    },
    playRecordingVideo: function () {
      if (this.$refs.recordingVideo && this.isRecordingVideoLoaded) {
        this.isRecordingVideoPaused = false
        this.$refs.recordingVideo.play()
        this.startSyncingRecordingVideoCurrentTimeWithTimeline()
      }
    },
    pauseRecordingVideo: function () {
      if (this.$refs.recordingVideo) {
        this.isRecordingVideoPaused = true
        this.$refs.recordingVideo.pause()
        this.stopSyncingRecordingVideoCurrentTimeWithTimeline()
      }
    },
    playThumbnailVideo: function () {
      if (this.$refs.thumbnailVideo && this.isThumbnailVideoLoaded) {
        this.isThumbnailVideoPaused = false
        this.$refs.thumbnailVideo.play()
        this.startSyncingThumbnailVideoCurrentTimeWithTimeline()
      }
    },
    pauseThumbnailVideo: function () {
      if (this.$refs.thumbnailVideo) {
        this.isThumbnailVideoPaused = true
        this.$refs.thumbnailVideo.pause()
        this.stopSyncingThumbnailVideoCurrentTimeWithTimeline()
      }
    },
    startSyncingRecordingVideoCurrentTimeWithTimeline: function () {
      this.stopSyncingRecordingVideoCurrentTimeWithTimeline()
      this.syncingRecordingVideoCurrentTimeWithTimeline$i = setInterval(() => {
        this.resetTimeIndexes()
      }, 300)
    },
    stopSyncingRecordingVideoCurrentTimeWithTimeline: function () {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingRecordingVideoCurrentTimeWithTimeline$i)
        this.resetTimeIndexes()
      }
    },
    startSyncingThumbnailVideoCurrentTimeWithTimeline: function () {
      this.stopSyncingThumbnailVideoCurrentTimeWithTimeline()
      this.syncingThumbnailVideoCurrentTimeWithTimeline$i = setInterval(() => {
        this.resetTimeIndexes()
      }, 300)
    },
    stopSyncingThumbnailVideoCurrentTimeWithTimeline: function () {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingThumbnailVideoCurrentTimeWithTimeline$i)
        this.resetTimeIndexes()
      }
    },
    resetTimeIndexes: function () {
      if (this.$refs.thumbnailVideo) {
        let time = this.$refs.thumbnailVideo.currentTime
        let minuteIndex = Math.floor(time / this.oneMinuteInThumbnailVideo)
        let hourIndex = Math.floor(time / this.oneHourInThumbnailVideo)
        minuteIndex = minuteIndex % this.minutes.length
        hourIndex = hourIndex % this.hours.length
        this.selectMinute(minuteIndex)
        this.selectHour(hourIndex)
      }
    },
    onClickRecordingVideoPlaybackRate: function () {
      let index = this.recordingVideoDefaultPlaybackRateIndex + 1
      if (index >= this.recordingVideoPlaybackRates.length) index = 0
      this.recordingVideoDefaultPlaybackRateIndex = index
      this.setRecordingVideoDefaultPlaybackRate()
    },
    onClickThumbnailVideoPlaybackRate: function () {
      let index = this.thumbnailVideoDefaultPlaybackRateIndex + 1
      if (index >= this.thumbnailVideoPlaybackRates.length) index = 0
      this.thumbnailVideoDefaultPlaybackRateIndex = index
      this.setThumbnailVideoDefaultPlaybackRate()
    },
    enableFullSceen: function () {
      this.isFullSceenActive = true
    },
    disableFullSceen: function () {
      this.isFullSceenActive = false
    }
  }
}
</script>

<style>
  .camera {
    font-size: 16px;
    background-color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    transform: scale(1);
    transition: transform .3s;
  }
  .camera.full-screen {
    background-color: #000;
  }


  .camera .header {
    position: absolute;
    top: 0;
    width: 100%;
    height: 3rem;
    z-index: 100;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    color: #000;
    background-color: rgba(255,255,255,0.35);
  }
  .camera .header .header-title {
    width: calc(100% - 40px - 40px - 1rem);
    text-align: center;
    position: relative;
    background: transparent;
    z-index: 0;
  }
  .camera .header .close-btn {
    width: 40px;
    height: 40px;
    cursor: pointer;
    position: relative;
    margin-left: 0.5rem;
    touch-action: manipulation;
  }
  .camera .header .close-btn svg {
    fill: currentColor;
    width: 28px;
    height: 28px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    touch-action: manipulation;
  }


  .camera .main {
    z-index: 2;
    position: relative;
    width: 100%;
    max-width: calc((100vh - 200px - 48px) * 16/9);
    height: 100%;
    touch-action: manipulation;
    overflow-y: hidden;
  } 
  .camera.full-screen .main {
    max-width: calc((100vh) * 16/9);
    background-color: #000;
  }

  .camera .body {
    padding: 0;
    background-color: #fff;
    width: 100%;
    height: calc(100% - 3rem);
    touch-action: manipulation;
    margin-top: 3rem;
    transition: margin .3s;
  }
  .camera.full-screen .main .body {
    margin-top: calc( (100vh - (100% /16*9)) /2 );
    height: calc(100% - ((100vh - (100vw /16*9)) /2));
    background-color: transparent;
    display: flex; 
    flex-direction: row; 
    align-items: flex-start;  
  }

  .camera .body .camera-container {
    width: 100%;
    position: relative;
    background-color: #222;
    color: #fff;
    touch-action: manipulation;
  }
  .camera .body .camera-container:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: 56.25%;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content img {
    width: 100%;
    height: 100%;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content .no-recording-text {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    cursor: pointer;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content video::-webkit-media-controls {
    display: none;
  }
  .camera .body .camera-container > .content .control-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content .control-container .clickable-layer {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    touch-action: manipulation;
    z-index: 1;
  }
  .camera .body .camera-container > .content .control-container .video-info {
    width: 220px;
    height: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: rgba(0,0,0,0.6);
    position: absolute;
    bottom: 1rem;
    border-radius: 4px;
    font-size: 14px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(255,255,255,0.8);
    z-index: 2;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content .control-container .video-info .info-title {
    position: absolute;
    top: 50%;
    right: 1em;
    transform: translateY(-50%);
    color: #fff;
    text-transform: uppercase;
    font-size: 10px;
    border-radius: 4px;
    width: 70px;
    height: 2em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    background-color: hsla(210, 90%, 50%, 0.8);
    cursor: pointer;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content .control-container .video-info .info-text {
    padding: 0;
    width: 100%;
    padding-left: 0;
    padding-right: 80px;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content .control-container .video-info.playback .info-title {
    left: 1em;
    background-color: hsla(40, 90%, 50%, 0.8);
  }
  .camera .body .camera-container > .content .control-container .video-info.playback .info-text {
    padding-left: 80px;
    padding-right: 0;
  }

  .camera .body .camera-container > .content .control-container .loading-status {
    background-color: transparent;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.5;
    z-index: 2;
    touch-action: manipulation;
  }

  .camera .body .camera-container > .content .control-container .playback-control-container {
    position: absolute;
    height: 60px;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    z-index: 2;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content .control-container .playback-control-container .control-btn {
    width: 60px;
    height: 60px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0.5;
    z-index: 2;
    touch-action: manipulation;
  }
  .camera .body .camera-container > .content .control-container .playback-control-container .control-btn svg {
    width: 48px;
    height: 48px;
    fill: currentColor;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    touch-action: manipulation;
  }



  .camera .footer {
    position: absolute;
    z-index: 1000;
    bottom: 0;
    left: 0;
    padding: 0;
    background-color: rgba(255,255,255,0.35);
    width: 100%;
    cursor: pointer;
    touch-action: manipulation;
  }
  .camera .footer .camera-control-container {
    /* padding: 1em 0; */
    display: flex;
    flex-direction: column;
    overflow: hidden;
    touch-action: manipulation;
  }
  .camera .footer .camera-control-container .action-btns {
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    touch-action: manipulation;
  }
  .camera .footer .camera-control-container .action-btns .action-btn {
    padding: 0;
    text-transform: capitalize;
    font-size: 14px;
    width: 110px;
    height: 3em;
    background-color: rgba(240,240,240,0.8);
    /* border-radius: 4px; */
    /* margin: 0 2px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: rgba(0,0,0,0.5);
    touch-action: manipulation;
  }
  .camera .footer .camera-control-container .action-btns .action-btn:hover {
    background-color: rgba(240,240,240,1);
  }
  .camera .footer .camera-control-container .action-btns .action-btn.selected {
    background-color: hsla(210, 90%, 50%, 0.8);
    color: rgba(255,255,255,0.9);
    font-weight: bold;
  }
  .camera .footer .camera-control-container .action-btns .action-btn.selected.playback {
    background-color: hsla(40, 90%, 50%, 0.8);
  }
  .camera .footer .camera-control-container .timeline-container {
    padding: 1em 0;
    color: #000;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    touch-action: manipulation;
  }
  .camera .footer .camera-control-container .timeline-container .dates-container {
    padding: 0;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    height: 3em;
    position: relative;
    touch-action: manipulation;
  }
  .camera .footer .camera-control-container .timeline-container .dates-container .date {
    padding: 0;
    background-color: rgba(240,240,240,0.8);
    width: 100px;
    height: 3em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: rgba(0,0,0,0.2);
    transition: color .3s;
    touch-action: manipulation;
  }
  .camera .footer .camera-control-container .timeline-container .dates-container .date:hover {
    background-color: hsl(210, 0%, 96%);
  }
  .camera .footer .camera-control-container .timeline-container .dates-container .date.has-recording {
    color: hsla(40, 90%, 40%, 0.8); 
  }
  .camera .footer .camera-control-container .timeline-container .dates-container .date.selected {
    background-color: hsla(40, 90%, 50%, 0.8);
    color: rgba(255,255,255,0.8);
    font-weight: bold;
  }
  .camera .footer .camera-control-container .timeline-container .dates-container .date.selected.has-recording {
    color: rgba(255,255,255,0.8);
    font-weight: bold;
  }





  /* @media screen and (min-width: 1280px) {
    .camera .main{
      max-width: calc((100vh - 200px - 48px) * 16/10);
    }
  } */

  /* @media screen and (min-width: 1280px)  and (min-aspect-ratio: 16/10) {
    .camera .main{
      max-width: calc((100vh - 200px - 48px) * 16/10);
    }
  } */

  @media only screen and (max-height: 480px) { 
    .camera .main{
      max-width: calc((100vh) * 16/9);
    }
    .camera .footer{
      display: none;
    } 
    .camera .main .body {
      margin-top: 0;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  @media only screen and (max-width: 1280px) and (min-aspect-ratio: 16/10) { 
    .camera .main{
      max-width: calc((100vh) * 16/9);
    }
    .camera .footer{
      display: none;
    } 
    .camera .main .body {
      margin-top: 0;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

</style>



// WEBPACK FOOTER //
// Camera.vue?725598d4